module.exports = __webpack_public_path__ + "img/avatar.376291e1.png";